import type { BFFArticleBodyElement } from "@src/app/types/bff";

function withEnableJsApi(url: string): string {
  if (!url) return url;
  if (url.includes("enablejsapi=1")) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}enablejsapi=1`;
}

export default function ArticleYoutube({
  element,
}: {
  element: BFFArticleBodyElement["youtube_video"];
}) {
  return (
    <div className="pb-4">
      <iframe
        className="aspect-3/2 w-full"
        src={withEnableJsApi(element.url)}
        title={element.title}
        allowFullScreen
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
      />

      {/* Does not support description for YouTube videos in the current implementation */}
      {/* Uncomment if description support is added in the future */}
      {/* {element.description ? (
        <p className="mt-4 mx-3 text-tertiary text-body-2 text-center">
          {element.description}
        </p>
      ) : null} */}
    </div>
  );
}
